import type CopyWorkOrderVM from 'ab-viewModels/workOrder/copyWorkOrders.viewModel';

import type CopyWorkOrderRM from 'ab-requestModels/workOrder/copyWorkOrders.requestModel';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

export const fromVMtoRM = (vm: CopyWorkOrderVM): CopyWorkOrderRM => {
	return {
		orderId: vm.orderId,
		code: vm.code,
		startDate: TimeUtils.formatDate(vm.startDate, TimeFormat.DB_DATE_ONLY),
		endDate: vm.endDate ? TimeUtils.formatDate(vm.endDate, TimeFormat.DB_DATE_ONLY) : TimeUtils.getNextDayDate(vm.startDate, TimeFormat.DB_DATE_ONLY),
		copyDate: TimeUtils.formatDate(vm.copyDate, TimeFormat.DB_DATE_ONLY),
		shouldPreserveIndex: true,
		intervalSelection: false,
		monday: !!vm.monday,
		tuesday: !!vm.tuesday,
		wednesday: !!vm.wednesday,
		thursday: !!vm.thursday,
		friday: !!vm.friday,
		saturday: !!vm.saturday,
		sunday: !!vm.sunday,
		shouldCopyAttachments: false,
		shouldCopyPreviousReportTypes: false,
		selectedOrdersIds: vm.selectedOrdersIds,
	};
};

class WorkDaysFM {
	monday?: boolean;
	tuesday?: boolean;
	wednesday?: boolean;
	thursday?: boolean;
	friday?: boolean;
	saturday?: boolean;
	sunday?: boolean;

	constructor(workDays: WorkDaysFM = {}) {
		this.monday = !!workDays.monday;
		this.tuesday = !!workDays.tuesday;
		this.wednesday = !!workDays.wednesday;
		this.thursday = !!workDays.thursday;
		this.friday = !!workDays.friday;
		this.saturday = !!workDays.saturday;
		this.sunday = !!workDays.sunday;
	}
}

export class WorkOrderCopyFM extends WorkDaysFM {
	orderId?: number;
	selectedOrdersIds?: number[];
	code?: string;
	intervalSelection: boolean;
	/** YYYY-MM-DD */
	startDate: string;
	/** YYYY-MM-DD */
	endDate: string;
	/** YYYY-MM-DD */
	copyDate: string;
	shouldPreserveIndex: boolean;
	validOrders?: string[];
	finishedOrders?: string[];
	cancelledOrders?: string[];

	constructor(
		startDate: string,
		copyDate: string,
		workingWeekDays: WorkDaysFM,
		validOrders: string[] = [],
		finishedOrders: string[] = [],
		cancelledOrders: string[] = [],
		selectedOrdersIds?: number[],
		code?: string
	) {
		super(workingWeekDays);

		this.startDate = TimeUtils.formatDate(startDate, TimeFormat.DB_DATE_ONLY);
		this.copyDate = TimeUtils.formatDate(copyDate, TimeFormat.DB_DATE_ONLY);
		this.validOrders = validOrders;
		this.finishedOrders = finishedOrders;
		this.cancelledOrders = cancelledOrders;
		this.selectedOrdersIds = selectedOrdersIds;
		this.code = code;
	}
}
